'use strict';

angular.module('ClinicApp').directive('userInfo', function(CurrentUser, OCValidationUtil, UserService) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_user-info.html',
    link: function($scope) {
      loadUser();

      $scope.checkName = function(name) {
        if (!angular.isUndefined(name.firstName) && !name.firstName) {
          return 'Please enter your first name.';
        }
        if (!angular.isUndefined(name.lastName) && !name.lastName) {
          return 'Please enter your last name.';
        }
      };

      $scope.saveName = function() {
        return save({
          firstName: $scope.user.firstName,
          lastName: $scope.user.lastName,
        });
      };

      $scope.saveEmail = function(email) {
        if (!OCValidationUtil.isValidEmail(email)) {
          return 'Please enter a valid email address.';
        }
        return save({
          email: email,
        });
      };

      function save(data) {
        return UserService.updateCurrentUser(data).then(function() {
          CurrentUser.update(loadUser);
        });
      }

      function loadUser() {
        return CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function(user) {
          $scope.user = user;
        });
      }
    },
  };
});
